/** 
* 自动生成文件，请勿修改 
* @name: 职位：职位级别月度目标产值配置
* @description: 职位月度目标产值配置（三期新增）
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:7条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const positionAchiev = { 
	/** 1 summary:分页查询	method:post */ 
	queryPage : new APIObject("/api/positionAchiev/queryPage.do"), 
	/** 2 summary:保存/修改	method:post */ 
	saveOrUpd : new APIObject("/api/positionAchiev/saveOrUpd.do"), 
	/** 3 summary:所有数据查询	method:post */ 
	queryAll : new APIObject("/api/positionAchiev/queryAll.do"), 
	/** 4 summary:单条数据查询	method:post */ 
	queryOne : new APIObject("/api/positionAchiev/queryOne.do"), 
	/** 5 summary:批量保存/修改	method:post */ 
	batchSaveOrUpd : new APIObject("/api/positionAchiev/batchSaveOrUpd.do"), 
	/** 6 summary:单条删除	method:post */ 
	delete : new APIObject("/api/positionAchiev/delete.do"), 
	/** 7 summary:批量删除	method:post */ 
	batchDelete : new APIObject("/api/positionAchiev/batchDelete.do"), 
};
export default positionAchiev;